// Solid-sphere rolling acceleration in the island's local coordinate frame.
// Gravity is transformed by the inverse of Three.js Euler XYZ (yaw is zero).
export function gravityOnTerrain(pitch,roll,hx=0,hz=0,g=9.81){
 const gx=-g*Math.cos(pitch)*Math.sin(roll),gy=-g*Math.cos(pitch)*Math.cos(roll),gz=g*Math.sin(pitch);
 const inv=1/Math.hypot(hx,1,hz),nx=-hx*inv,ny=inv,nz=-hz*inv,dot=gx*nx+gy*ny+gz*nz;
 return {x:(gx-dot*nx)*5/7,z:(gz-dot*nz)*5/7};
}
export function advanceRolling(state,dt,{pitch,roll,heightAt,bound=3.42,damping:drag=1.45,maxSpeed=2.4}){
 const steps=Math.max(1,Math.ceil(Math.min(dt,.1)/(1/120))),h=Math.min(dt,.1)/steps;
 for(let i=0;i<steps;i++){
  const hx=(heightAt(state.x+.045,state.z)-heightAt(state.x-.045,state.z))/.09;
  const hz=(heightAt(state.x,state.z+.045)-heightAt(state.x,state.z-.045))/.09;
  const a=gravityOnTerrain(pitch,roll,hx,hz);state.vx+=a.x*h;state.vz+=a.z*h;
  const damping=Math.exp(-drag*h);state.vx*=damping;state.vz*=damping;
  const speed=Math.hypot(state.vx,state.vz),cap=maxSpeed;if(speed>cap){state.vx*=cap/speed;state.vz*=cap/speed;}
  if(Math.hypot(a.x,a.z)<.035&&Math.hypot(state.vx,state.vz)<.018)state.vx=state.vz=0;
  state.x+=state.vx*h;state.z+=state.vz*h;
  if(state.x>bound){state.x=bound;if(state.vx>0)state.vx*=-.12;}if(state.x<-bound){state.x=-bound;if(state.vx<0)state.vx*=-.12;}
  if(state.z>bound){state.z=bound;if(state.vz>0)state.vz*=-.12;}if(state.z<-bound){state.z=-bound;if(state.vz<0)state.vz*=-.12;}
 }return state;
}
